import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLDetailsElement> {
  private abortController?: AbortController;

  connect() {
    this.abortController = new AbortController();

    document.addEventListener("click", this.closeFromOutsideClick, this.listenerOptions);
    document.addEventListener("keydown", this.closeFromEscape, this.listenerOptions);
  }

  disconnect() {
    this.abortController?.abort();
  }

  private closeFromOutsideClick = (event: MouseEvent) => {
    if (!this.element.open) return;
    if (event.target instanceof Node && this.element.contains(event.target)) return;

    this.element.open = false;
  };

  private closeFromEscape = (event: KeyboardEvent) => {
    if (event.key !== "Escape") return;

    this.element.open = false;
  };

  private get listenerOptions() {
    return { signal: this.abortController?.signal };
  }
}
